export default abstract class TrackingProvider {
    private _providerUrl: string;
    protected _active: boolean = false;
    protected _trackingIds: string[] = [];
    protected _inDebugMode: boolean = process.env.MIX_TRACKING_PROVIDERS_DEBUG?.toLowerCase() === 'true';

    protected loadScript = (src: string, element?: HTMLScriptElement) => {
        const firstScript = document.getElementsByTagName('script')[0];
        const script = element ?? document.createElement('script');
        script.async = true;
        script.src = src;
        firstScript.parentNode.insertBefore(script, firstScript);
        this._providerUrl = src;
        this.debug('loadScript:', this.providerUrl);
    };

    protected extractCleanTrackingIds = (trackingIds: string) =>
        trackingIds
            ?.split(',')
            .map((s) => s.trim())
            .filter((s) => s.length > 0) ?? [];

    public get isActive(): boolean {
        return this._active;
    }

    public get trackingIds(): string[] {
        return this._trackingIds;
    }

    public get firstTrackingId(): string {
        return this._trackingIds[0];
    }

    public get providerUrl(): string {
        return this._providerUrl;
    }

    protected debug(...args: any): void {
        if (this._inDebugMode) {
            // eslint-disable-next-line no-console
            console.log('[debug]', ...args);
        }
    }

    abstract initialize(trackingIds: string): TrackingProvider;
}
